export const EMPTY_TITLE_CODE = "empty";
